import ApiService from "./ApiService";

export async function apiSignInRequest(data) {
  return ApiService.fetchData({
    url: "/common/auth/login",
    method: "post",
    data,
  });
}
